'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$163(ps$89) {
  this.a6W = null;
  this.a6W = ps$89;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$163 as $c_Lmealorama_jsonCodecs$package$$anon$163 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$163.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$163;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$163() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$163 as $h_Lmealorama_jsonCodecs$package$$anon$163 };
$h_Lmealorama_jsonCodecs$package$$anon$163.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6W.a.length;
});
$p.g = (function(i) {
  return this.a6W.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$163 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$163, "mealorama.jsonCodecs$package$$anon$163", ({
  Jg: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$163 as $d_Lmealorama_jsonCodecs$package$$anon$163 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$163.js.map
